import * as yup from 'yup';

export const textErrors = {
  REQ_FIELD: 'Обязательное поле',
  NOT_CORRECT_EMAIL: 'Некорректный email',
  PASS_LENGHT: 'Пароль должен содержать не менее 8 символов',
  PASS_FALIDATE: 'Неверный формат пароля',
  PASS_SAME: 'Пароли должны совпадать'
};

export const email = yup
  .string()
  .required(textErrors.REQ_FIELD)
  .email(textErrors.NOT_CORRECT_EMAIL);

export const password = yup
  .string()
  .required(textErrors.REQ_FIELD)
  .min(8, textErrors.PASS_LENGHT)
  .matches('(?=.*?[A-Z])(?=.*?[0-9])', textErrors.PASS_FALIDATE);

export const reqFiled = yup.string().required(textErrors.REQ_FIELD);
